import { EnvironmentContract } from './environment.contract';

export const commonEnvironment: EnvironmentContract = {
  production: false,
  secretKey: 'ENV_SECRET_KEY',
  urlLandingPage: 'https://www.nequi.com.co',
  ssoUrl: 'http://localhost:8080',
  helpUrl: 'https://ayuda.nequi.com.co/hc/es/articles/115001895652-Quiero-pagar-con-Nequi-por-PSE',
  keycloakCSI: 'keycloakCSI',
  clevertapKey: '9W8-ZKR-695Z',
  dynatraceScriptUrl: 'https://js-cdn.dynatrace.com/jstag/17b628055ae/bf64848bdm/fea75dc649a44b89_complete.js',
  firebaseConfig: {
    apiKey: 'ENV_FIREBASE_API_KEY',
    authDomain: 'nequiqa-d9754.firebaseapp.com',
    projectId: 'nequiqa-d9754',
    storageBucket: 'nequiqa-d9754.appspot.com',
    messagingSenderId: '1070976873160',
    appId: '1:1070976873160:web:e15dc3f34f58f473ef2bfd',
    measurementId: 'G-MPDXYPJH8F',
  },
  apiServices: {
    apiUrl: 'https://paymentpse-qa.bancadigital.com.co/api/v1',
    biocatchUrl: '@@BIOCATCH_URL@@',
  },
};
